<div class="wrap">
    <h3>{{data.title}}</h3>
    <p>{{data.text}}</p>
    <div class="btn_action">
        <button class="back" (click)="dialogRef.close()">non</button>
        <button class="confirm" [mat-dialog-close]="true">oui</button>
    </div>
</div>